var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',{attrs:{"enable-flex":""}},[_c('div',{staticClass:"main flex-grow",on:{"click":_vm.tips}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }